import React, { useState } from "react";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";

const FormGeneralSetting = ({ formSettingData, setIsModalOpen }) => {
  const [formName, setFormName] = useState(formSettingData.current.name);
  const [settings, setSettings] = useState(formSettingData.current.settings);
  const [submit, setsubmit] = useState(formSettingData.current.submit_button);
  const [formStyle, setFormStyle] = useState(formSettingData.current.style);
  const [formReset, setFormReset] = useState(formSettingData.current.reset_button);
  const [isPositionedForm, setIsPositionedForm] = useState(formSettingData.current.is_positioned_form);
  const [useLocalStorage, setUseLocalStorage] = useState(
    formSettingData.current?.settings?.ignore_local_storage || false
  );

  const handleCheckboxChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.checked });
  };

  const handleProcessBarColor = (e) => {
    setSettings({
      ...settings,
      progress_bar_color_codes: { ...settings.progress_bar_color_codes, [e.target.name]: e.target.value }
    });
  };

  const handleLocalStorageChange = (e) => {
    setUseLocalStorage(e.target.checked);
  };

  const handleFormStyleChange = (e) => {
    setFormStyle({ ...formStyle, [e.target.name]: e.target.value });
  };
  const handleFormResetChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormReset({ ...formReset, [name]: type === "checkbox" ? checked : value });
  };
  const handleChangePositionedForm = (e) => {
    setIsPositionedForm(e.target.checked);
  };

  const saveFormSettings = () => {
    if (formName.trim().length < 3) return;
    const tempObj = {
      name: formName,
      settings: {
        ...settings,
        ignore_local_storage: useLocalStorage
      },
      submit_button: submit,
      style: formStyle,
      reset_button: formReset,
      is_positioned_form: isPositionedForm
    };

    formSettingData.current = tempObj;
    setIsModalOpen(false);
  };
  return (
    <div className="builder_form">
      <Input label="Form name" type="text" value={formName} name="" onChange={(e) => setFormName(e.target.value)} />
      <Input label="Submit button" type="text" value={submit} name="" onChange={(e) => setsubmit(e.target.value)} />
      <Input
        label="Min Width (in pX)"
        type="number"
        value={formStyle.min_width}
        name="min_width"
        onChange={handleFormStyleChange}
      />
      <Input
        label="Width (in VW)"
        type="number"
        value={formStyle.width}
        name="width"
        onChange={handleFormStyleChange}
      />
      <Input
        label="Max Width (in pX)"
        type="number"
        value={formStyle.max_width}
        name="max_width"
        onChange={handleFormStyleChange}
      />

      <Input
        type="checkbox"
        label="Is Positioned Form"
        checked={isPositionedForm}
        name="is_positioned_form"
        onChange={handleChangePositionedForm}
      />
      <Input
        type="checkbox"
        label="Show reset button"
        checked={formReset?.show_reset}
        name="show_reset"
        onChange={handleFormResetChange}
      />

      <Input
        label="Reset Button"
        type="text"
        value={formReset?.reset_label}
        name="reset_label"
        onChange={handleFormResetChange}
      />

      <Input
        type="checkbox"
        label="Fetch Fresh Data"
        checked={useLocalStorage}
        name="ignore_local_storage"
        onChange={handleLocalStorageChange}
      />

      {formSettingData.current.settings?.isMultiple && (
        <>
          <Input
            type="checkbox"
            label="Show progress bar"
            checked={settings.progress_bar}
            name="progress_bar"
            onChange={handleCheckboxChange}
          />
          <Input
            type="checkbox"
            label="Progress bar clickable"
            checked={settings.progress_bar_clickable}
            name="progress_bar_clickable"
            onChange={handleCheckboxChange}
          />
          <Input
            label="Color when field empty"
            type="color"
            value={settings.progress_bar_color_codes.empty}
            name="empty"
            onChange={handleProcessBarColor}
          />
          <Input
            label="Color when field valid"
            type="color"
            value={settings.progress_bar_color_codes.filled_valid}
            name="filled_valid"
            onChange={handleProcessBarColor}
          />
          <Input
            label="Color when field inValid"
            type="color"
            value={settings.progress_bar_color_codes.filled_invalid}
            name="filled_invalid"
            onChange={handleProcessBarColor}
          />
          <Input
            label="Color when field inComplete"
            type="color"
            value={settings.progress_bar_color_codes.filled_incomplete}
            name="filled_incomplete"
            onChange={handleProcessBarColor}
          />
        </>
      )}
      <Button onClick={saveFormSettings}>Edit</Button>
    </div>
  );
};

export default FormGeneralSetting;
